import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import './style.scss';
import worldImg from '../../../../assets/t-206/world.png';
import DownloadButton from '../../../download-button';

type Props = {
    onComplete?: () => void
}

const Task206: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-206');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-206">
        <h2>zadanie 6</h2>
        <h3>{task?.title}</h3>
        <p>Przygotowaliśmy dla Was kilka propozycji książek podróżniczych. Sprawdźcie, czy macie je w bibliotece. A może znajdziecie inne, które warto dodać do tej listy?</p>
        <p className="instruction"><strong>Zadanie:</strong> Posiłkując się książkami i Waszą wyobraźnią zaplanujcie podróż dookoła świata. Wykorzystajcie mapę świata, którą przygotowaliśmy, żeby rozrysować szczegółowy plan. Nie zapomnijcie o miejscach, które chcecie odwiedzić, drogach, które chcecie przebyć, środkach transportu, które chcecie wypróbować i ludziach, których chcecie spotkać!<br />
            Książkowe inspiracje do planowania podróży dookoła świata:
        </p>
        <ul>
            <li><span>MAPY. Obrazkowe podróże po lądach, morzach i kulturach świata</span>, Aleksandra i Daniel Mizielińscy</li>
            <li><span>Atlas miast. Podróżuj po świecie z przewodnikiem po 30 miastach</span>, Tekst: Georgia Cherry, Ilustracje: Martin Haake</li>
            <li><span>Biuro detektywistyczne Lassego i Mai: Tajemnica kempingu, Tajemnica pociągu, Tajemnica hotelu</span>, Martin Widmark, Helena Willis</li>
            <li><span>Przygody Tomka Sawyera</span>, Mark Twain</li>
            <li><span>Rzym dla młodych podróżników, Paryż dla młodych podróżników, Barcelona dla młodych podróżników, Londyn dla młodych podróżników (i inne)</span>, Marta Spingardi</li>
        </ul>
        <img src={worldImg} alt="mapa świata" />
        <div className="buttons">
            <DownloadButton src={worldImg} file='mapa.jpg' />
        </div>
    </div>
}

export default Task206;
